import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { DisplayFieldsFragment } from '../../../../generated/core-api/graphql-react-query';

export default function useUpdateDisplay() {
  const queryClient = useQueryClient();
  const updateDisplay = React.useCallback((display: DisplayFieldsFragment) => {
    queryClient.setQueryData(['getLiveDisplay', { input: { id: display.id } }], { getDisplay: display });
  }, []);

  return updateDisplay;
}
